<template>
    <div class="view-selector" id="view-selector">
        <survey-button
            v-for="viewOption in viewOptions"
            :key="viewOption.key"
            class="view-selector-btn"
            @click="setView(viewOption.key)"
            :variant="view === viewOption.key ? 'primary' : 'transparent'"
        >
            {{ viewOption.name }}
        </survey-button>
    </div>
    <div id="pit-report" v-if="view === 'default'">
        <page>
            <survey-title style="text-align: center">{{ $t('reportsWeb.TEAM_REPORT_TITLE') }}</survey-title>
            <pit-wheel-wrapper ref="chart" :reportData="reportData" :filteredParticipants="filteredParticipants" />
            <div>
                <survey-translate class="participant-title" tag="div" base="reportsWeb" name="PARTICIPANT_LIST_TITLE" />
                <div class="participant-list-wrapper">
                    <survey-checkbox
                        v-for="participant in participants"
                        :key="`filter_${participant.participantId}`"
                        id="participant-list"
                        :name="`filter_${participant.participantId}`"
                        :modelValue="participantSelected(participant.participantId)"
                        @input="toggleParticipant(participant.participantId)"
                        class="project-checkbox"
                    >
                        <div class="project-checkbox-label">
                            <div>{{ participant.participantName }}</div>
                        </div>
                    </survey-checkbox>
                </div>
            </div>
        </page>
        <page v-for="(constructs, index) in constructPairs" :key="constructs">
            <survey-translate v-if="index === 0" tag="h2" base="reportsWeb" name="CROSS_TITLE" />
            <pit-cross :participants="crossParticipants" :visible-constructs="constructs" disable-comparer />
        </page>
    </div>
    <div v-else-if="view === 'cross'">
        <survey-translate tag="h2" base="reportsWeb" name="CROSS_TITLE" />
        <pit-cross :participants="crossParticipants" />
    </div>
</template>
<script src="./PitTeam.ts" lang="ts"></script>
<style lang="scss">
#participant-list {
    margin-bottom: 0.25rem;
}

.participant-title {
    font-size: medium;
    font-weight: bold;
    margin-bottom: 1rem;
}

.view-selector {
    display: flex;
    overflow: hidden;
    border: 1px solid #9e9e9e;

    .view-selector-btn {
        width: 100%;
    }
}

.participant-list-wrapper {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
}
</style>
